var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"half-hour-block__container",style:({
        'min-height': _vm.pixelBasePerMinute + 'px',
        'max-height': _vm.pixelBasePerMinute + 'px'
    }),on:{"click":function (event) { return _vm.$emit('click', event, _vm.period); }}})}
var staticRenderFns = []

export { render, staticRenderFns }